import { Injectable, TemplateRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { JsonService } from '../json/json.service';
import { Http } from '@angular/http';

@Injectable()
export class HeaderService extends JsonService {

  private _state = new BehaviorSubject<TemplateRef<any> | null>(null);
  readonly contents = this._state.asObservable();

  constructor(public http: Http) {
    super(http);
  }

  setContents(ref: TemplateRef<any>): void {
    this._state.next(ref);
  }

  clearContents(): void {
    this._state.next(null);
  }

}
